import { useContext } from "react"
import { AsideActionContext } from "~/utils/contextes"
import { confirmCloseAction } from "../ActionUtils"

export const useCloseAction = () => {
    const { isDirty, resetAction, asideAction } = useContext(AsideActionContext)

    return async (forceClose = false) => {
        if (asideAction && isDirty && !forceClose) {
            const confirm = await confirmCloseAction()
            if (!confirm) {
                return false
            }
        }
        resetAction()
        return true
    }
}